import React, { Component } from 'react';
import { Map, TileLayer, Marker, Pane, Tooltip } from 'react-leaflet';
import { SearchHelper } from '../../helpers/SearchHelper';

import { stopIcon } from '../../../components/leaflet/StopIcon';

export class StopsMap extends Component {
    renderMarker(stop, idx) {
        if (stop.hidden) {
            return null;
        }

        return (
            <Marker key={stop.id}
                position={stop.position !== undefined ? stop.position : [0, 0]}
                icon={stopIcon}
                draggable={true}
                onDragend={(e) => this.props.onDragend(stop.id, e)}
                onClick={undefined === this.props.onClickEditStop ? null : () => this.props.onClickEditStop(stop.id)} >
                <Tooltip><span>{stop.name} ({stop.code})</span></Tooltip>
            </Marker>
        );
    }

    renderMarkers(stops) {
        if (undefined === stops) {
            return null;
        }

        return (
            <div>{stops.map((stop, idx) => this.renderMarker(stop, idx))}</div>
        );
    }

    getBounds(stops) {
        if (!Array.isArray(stops) || stops.length === 0) {
            return [
                [90, 180],
                [-90, -180]
            ];
        }

        const positions = stops
            .map(stop => stop.position)
            .filter(pos => Array.isArray(pos) && pos.length === 2 && pos.every(Number.isFinite));
        if (positions.length === 0) {
            return [
                [90, 180],
                [-90, -180]
            ];
        }

        let minLat = positions[0][0], maxLat = positions[0][0];
        let minLng = positions[0][1], maxLng = positions[0][1];
        for (let i = 1; i < positions.length; i++) {
            const [lat, lng] = positions[i];
            if (lat < minLat) minLat = lat;
            if (lat > maxLat) maxLat = lat;
            if (lng < minLng) minLng = lng;
            if (lng > maxLng) maxLng = lng;
        }
        return [
            [minLat, minLng],
            [maxLat, maxLng]
        ];
    }

    getDebouncedBounds(stops) {
        // This calculation is to avoid rapid map changes while typing
        if (!this._debounceTimeout) {
            this._debounceTimeout = null;
        }

        if (!this._lastBounds) {
            this._lastBounds = this.getBounds(stops);
        }

        // Calculate new bounds for stops
        const newBounds = this.getBounds(stops);

        // Only update bounds after user stops typing for 300ms
        if (this._debounceTimeout) {
            clearTimeout(this._debounceTimeout);
        }

        this._debounceTimeout = setTimeout(() => {
            this._lastBounds = newBounds;
            // Force update to re-render with new bounds
            this.forceUpdate();
        }, 300);

        return this._lastBounds;
    }


    render() {
        const { stops, filter } = this.props;
        let filteredStops = SearchHelper.search({
            filter: filter,
            data: stops,
            fields: ["code", "name", "lines"]
        });

        const bounds = this.getDebouncedBounds(filteredStops);

        return (
            <Map className="map-container"
                bounds={bounds}
                perfectCanvas={true}
                onClick={undefined === this.props.onClickCreateStop ? null : (e) => this.props.onClickCreateStop(e)} >
                <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Pane>{this.renderMarkers(filteredStops)}</Pane>
            </Map>
        );
    }
}
